import { fetch as fetchApi, isString } from "./api";
import { AxiosResponse } from "axios";

export async function fetch(id: string | null | undefined, params?: {}): Promise<AxiosResponse<any>> {
  return fetchApi({
    nestedResourcePath: ["mcc"],
    id,
    params
  })
    .then(response => {
      return response.data;
    })
}
